export function luhn36Check(str: string): boolean {
  let factor = 1;
  let sum = 0;

  for (let i = str.length - 1; i >= 0; i--) {
    const codePoint = Number.parseInt(str[i], 36);
    let addend = factor * codePoint;

    // Alternate the "factor" that each "codePoint" is multiplied by
    factor = factor === 2 ? 1 : 2;

    // Sum the digits of the "addend" as expressed in base "n"
    addend = Math.floor(addend / 36) + (addend % 36);
    sum += addend;
  }

  const remainder = sum % 36;

  return remainder === 0;
}
